import { render, staticRenderFns } from "./FlatList.vue?vue&type=template&id=5ae72b5f&"
import script from "./FlatList.vue?vue&type=script&lang=js&"
export * from "./FlatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports